import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLazyload from 'vue-lazyload';
import ContentSlider from '../vue/ContentSlider.vue';
import LazyImageBackground from '../vue/LazyImageBackground.vue';
import Navigation from '../vue/Navigation.vue';
import MobileNavigation from '../vue/MobileNavigation.vue';
import GoogleMap from '../vue/GoogleMap.vue';

export default {
  init() {
    let script = $('#smart-slider').children().detach();

    /* Vue
    ---------------------------------------------------------------------------------------------------- */

    Vue.config.productionTip = false;

    Vue.use(VueLazyload);

    Vue.use(VueGoogleMaps, {
      load: {
        key: 'AIzaSyBZ0Y9qjUe2Oh1YU2g1UnruacAOOvA-ybs',
      },
      installComponents: true,
    });

    new Vue({
      data: {
        topScrollThreshold: 100,
        isScrolled: false,
      },

      components: {
        ContentSlider,
        Navigation,
        MobileNavigation,
        LazyImageBackground,
        GoogleMap,
      },

      methods: {
        didScroll() {
          this.isScrolled = window.scrollY > this.topScrollThreshold;
        },
      },

      created() {
        window.addEventListener('scroll', this.didScroll);
      },

      destroyed() {
        window.removeEventListener('scroll', this.didScroll);
      },

      mounted() {},
    }).$mount('#app');


    $('#smart-slider').append(script);

  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js